import { useFeatureConfig } from "./useFeatureConfig";
import type { FeatureConfig, FeatureName } from "./FeatureConfig";

export function useFeature<T extends FeatureName>(name: T): FeatureConfig[T] {
  const featureConfig = useFeatureConfig();
  const featureValue = featureConfig[name];
  return featureValue as FeatureConfig[T];
}
